import { ICheckoutStep } from '@features/purchasing/types';
import React from 'react';

interface IProps {
  steps: ICheckoutStep[];
}

export default function CheckoutBreadcrumbs(props: IProps) {
  return (
    <div>
      <ul className="flex flex-col tablet:flex-row gap-y-2 py-4 text-xs text-gray-700">
        {props.steps.map((step, idx) => (
          <li
            key={step.url}
            className="flex items-center tablet:justify-center tablet:first:justify-start tablet:last:justify-end grow">
            <a
              href={step.isCurrent ? step.url : ''}
              className={`flex items-center gap-x-2 ${step.isCurrent ? 'font-semibold' : ''}`}>
              <span
                className={`w-6 h-6 inline-flex justify-center items-center rounded-full ${
                  step.isCurrent ? 'bg-primary text-white' : 'bg-gray-200 text-black'
                }`}>
                {idx + 1}
              </span>
              <span>{step.title}</span>
            </a>
            {idx + 1 < props.steps.length && (
              <span className="hidden icon ml-auto">
                <i className="fa-solid fa-chevron-right" />
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
